import React, { PureComponent } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Label } from "recharts";

export class ReportsStackedChart extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: [
        {
          name: "11am",
          pending: 20,
          notSeated: 2,
          rejected: 5,
          cancelled: 4,
          seated: 12,
          completed: 10,
        },
        {
          name: "12pm",
          pending: 20,
          notSeated: 4,
          rejected: 5,
          cancelled: 8,
          seated: 5,
          completed: 15,
        },
        {
          name: "1pm",
          pending: 20,
          notSeated: 6,
          rejected: 10,
          cancelled: 4,
          seated: 8,
          completed: 20,
        },
        {
          name: "2pm",
          pending: 20,
          notSeated: 8,
          rejected: 5,
          cancelled: 8,
          seated: 10,
          completed: 25,
        },
        {
          name: "3pm",
          pending: 20,
          notSeated: 10,
          rejected: 10,
          cancelled: 4,
          seated: 16,
          completed: 10,
        },
        {
          name: "4pm",
          pending: 20,
          notSeated: 12,
          rejected: 5,
          cancelled: 8,
          seated: 18,
          completed: 15,
        },
        {
          name: "5pm",
          pending: 20,
          notSeated: 14,
          rejected: 10,
          cancelled: 4,
          seated: 15,
          completed: 20,
        },
        {
          name: "6pm",
          pending: 20,
          notSeated: 16,
          rejected: 5,
          cancelled: 8,
          seated: 19,
          completed: 25,
        },
        {
          name: "7pm",
          pending: 20,
          notSeated: 18,
          rejected: 10,
          cancelled: 4,
          seated: 34,
          completed: 5,
        },
        {
          name: "8pm",
          pending: 20,
          notSeated: 10,
          rejected: 5,
          cancelled: 8,
          seated: 25,
          completed: 15,
        },
        {
          name: "9pm",
          pending: 20,
          notSeated: 12,
          rejected: 10,
          cancelled: 4,
          seated: 22,
          completed: 20,
        },
        {
          name: "10pm",
          pending: 20,
          notSeated: 24,
          rejected: 5,
          cancelled: 8,
          seated: 20,
          completed: 10,
        },
      ],
    };
  }
  render() {
    return (
      <React.Fragment>
        <div className="col-12 d-flex justify-content-center">
          <div className="date-chart-bar">
            <i className="fa fa-caret-left" aria-hidden="true"></i>
            <h5>05 May 2020</h5>
            <i className="fa fa-caret-right" aria-hidden="true"></i>
          </div>
        </div>
        <div className="stacked-chart-content">
          <BarChart
            width={600}
            height={292}
            data={this.state.data}
            margin={{ top: 0, right: 0, left: 0, bottom: 10 }}
          >
            <XAxis
              dataKey="name"
              stroke="#707070"
              fontSize="8"
              fontFamily="Roboto-Medium"
            >
              <Label
                value="Time"
                offset={-10}
                position="insideBottom"
                fontSize={13}
                fontFamily="Roboto-Regular"
              />
            </XAxis>
            <YAxis
              stroke="#707070"
              fontSize={13}
              fontFamily="Roboto-Regular"
              label={{
                value: "PAX",
                angle: -90,
                position: "insideLeft",
                offset: 15,
              }}
            />
            <Tooltip />
            {/* <Legend /> */}
            <Bar dataKey="notSeated" barSize={11} stackId="a" fill="#BAC21B" />
            <Bar dataKey="rejected" barSize={11} stackId="a" fill="#F46E19" />
            <Bar dataKey="cancelled" barSize={11} stackId="a" fill="#EA3925" />
            <Bar dataKey="seated" barSize={11} stackId="a" fill="#419E35" />
            <Bar dataKey="completed" barSize={11} stackId="a" fill="#225425" />
            <Bar dataKey="pending" barSize={11} stackId="a" fill="#FFC350" />
          </BarChart>
        </div>
      </React.Fragment>
    );
  }
}

export default ReportsStackedChart;
